import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import dayjs from "dayjs";

import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";

class PrintSolicitudes extends Component {
    state = {
        solicitudes: [],
    };
    componentDidMount() {
        this.getSolicitudes();
    }
    getSolicitudes = async () => {
        const response = await this.props.request(
            "solicitudes" + window.location.search
        );

        if (response.data) {
            this.setState({
                solicitudes: response.data,
            });
            window.print();
        }
    };
    render() {
        const { solicitudes } = this.state;
        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];
        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>Solicitudes</h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {new Date().toLocaleString()}
                    </div>
                    <div className='col-md-12 text-center p-b-10'></div>
                </div>
                <table className='table'>
                    <thead>
                        <tr>
                            <th style={{ width: "100px" }}>Fecha</th>
                            <th style={{ width: "60%" }}>Descripción</th>
                            <th>Creador</th>
                            <th style={{ width: "150px" }}>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {solicitudes.map((solicitud) => {
                            return (
                                <tr key={solicitud.id}>
                                    <td>
                                        {dayjs(solicitud.fecha).format(
                                            "DD/MM/YYYY"
                                        )}
                                    </td>
                                    <td>
                                        {solicitud.empleado ||
                                            (solicitud.vehiculo && (
                                                <div>
                                                    <small>
                                                        {solicitud.empleado}
                                                        {" - "}
                                                        {solicitud.vehiculo}
                                                    </small>
                                                </div>
                                            ))}
                                        <div style={{ whiteSpace: "pre-line" }}>
                                            {solicitud.descripcion}
                                        </div>
                                    </td>
                                    <td>
                                        {solicitud.creador}
                                        <br />
                                        <small>
                                            {solicitud.ultimaActividad}
                                        </small>
                                    </td>
                                    <td style={{ textTransform: "uppercase" }}>
                                        {solicitud.estado}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRouter(withRequest(PrintSolicitudes));
